import React, {useEffect, useState, useContext} from 'react';

import Modal from '../Modal/Modal';
import Input from '../Input/Input';
import AuthContext from "../../context/Services/Auth";

import {get_product} from "../../context/Services/Stock";

import { LuPackagePlus, LuBadgePercent } from "react-icons/lu";
import { TbFileDescription } from "react-icons/tb";
import {MdDriveFileRenameOutline, MdOutlinePriceCheck, MdLayers, MdPhotoSizeSelectLarge, MdPhotoSizeSelectSmall } from 'react-icons/md';
import { FaImages } from "react-icons/fa";
import { IoAddOutline } from "react-icons/io5";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaLayerGroup } from "react-icons/fa6";
import { IoMdPricetag } from "react-icons/io";
import { GoNumber } from "react-icons/go";
import { useTranslation } from 'react-i18next';


const ViewStockModal = ({show, setShow, stock_id}) => {
	const {t} = useTranslation();
	const { userData } = useContext(AuthContext);
	const [stock, setStock] = useState(null);

	const handle_get_product = (id) => {
		get_product(id)
			.then(res => {
				let json = res?.data;

				setStock({
				  product_name: json?.product_name,
				  quantity: json?.quantity,
				  product_note: json?.product_note,
				  image_path: json?.principal_image || json?.image_path,
				  buy_price: json?.buy_price,
				  sell_price: json?.sell_price,
				  comission: json?.comission,
				  category: json?.category,
				  sub_category: json?.sub_category, 
				  created: json?.created,
				  stock_details: json.stock_details
				})

			})
			.catch(e => console.log(e));
	}

	useEffect(() => {
		if(stock_id || stock_id?.length > 0){
			let id = typeof stock_id === "string" ? stock_id : stock_id[0];

			handle_get_product(id);
		}

	}, [stock_id])

	return (
		<Modal showBakcDrop={show} modal={show} hideModal={()=>{setShow(false)}}>
			{
				stock &&
				<>	
					<div className="w-full flex">
						{
							typeof stock_id !== "string" &&
							stock_id.map((elem, i) => (
								<div className="flex gap items-center filter_button" onClick={()=>handle_get_product(elem)} >
									<b>Produit ({i + 1})</b>
								</div>
							))
						}
					</div>

					<div className="flex flex-col gap w-full">
						{stock?.image_path ? (
							<img
								src={stock?.image_path}
								style={{height:"200px", width:"100%", objectFit:"contain"}}
							/>
						) : (
							<div className="flex items-center justify-center" style={{ height:"200px", width:"100%", backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
								<FaImages style={{ fontSize: '3rem', color: '#ccc' }} />
							</div>
						)}
					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Product name")}</h5>
						<Input 
						   label_text="Product name"
						   icon={<MdDriveFileRenameOutline className="icon_m"/>} 
						   placeholder="Product name" 
						   setChange={()=>{}} 
						   value={stock.product_name}
						   readOnly={true}
						/>
					</div>
					<div className="flex flex-col" style={{gap:"10px"}}>						
						<h5>{t("Total Quantity")}</h5>
						<Input 
						   label_text="Total Quantity"
						   icon={<GoNumber className="icon_m"/>} 
						   placeholder="Total Quantity" 
						   setChange={()=>{}} 
						   value={stock.quantity}
						   readOnly={true}
						/>
					</div>
					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Note")}</h5>
						<Input 
						   label_text="Note"
						   icon={<TbFileDescription className="icon_m"/>} 
						   placeholder="Note" 
						   setChange={()=>{}} 
						   value={stock.product_note}
						   readOnly={true}
						/>
					</div>
					{
						userData?.role !== "confirmer" &&
						<div className="flex flex-col" style={{gap:"10px"}}>
							<h5>{t("Prix d'achat")}</h5>
							<Input 
							   label_text="Prix d'achat"
							   icon={<IoMdPricetag className="icon_m"/>} 
							   placeholder="Prix d'achat" 
							   setChange={()=>{}} 
							   value={stock.buy_price}
							   readOnly={true}
							/>
						</div>
					}
					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Prix de Vente")}</h5>
						<Input 
						   label_text="Prix de Vente"
						   icon={<IoMdPricetag className="icon_m"/>} 
						   placeholder="Prix de Vente" 
						   setChange={()=>{}} 
						   value={stock.sell_price}
						   readOnly={true}
						/>
					</div>
					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Confirmation Commission")}</h5>
						<Input 
						   label_text="Confirmation Commission"
						   icon={<RiMoneyDollarCircleLine className="icon_m"/>} 
						   placeholder="Confirmation Commission" 
						   setChange={()=>{}} 
						   value={stock.comission}
						   readOnly={true}
						/>
					</div>

					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Category")}</h5>
						<Input 
						   label_text="Prix de Vente"
						   icon={<FaLayerGroup className="icon_m"/>} 
						   placeholder="Prix de Vente" 
						   setChange={()=>{}} 
						   value={stock.category.value}
						   readOnly={true}
						/>
					</div>

					<div className="flex flex-col" style={{gap:"10px"}}>
						<h5>{t("Sous-catégorie de produit")}</h5>
						<Input 
						   label_text="Prix de Vente"
						   icon={<FaLayerGroup className="icon_m"/>} 
						   placeholder="Prix de Vente" 
						   setChange={()=>{}} 
						   value={stock.sub_category.value}
						   readOnly={true}
						/>
					</div>

					</div>
				</>
			}
		</Modal>
	)
}

export default ViewStockModal